import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type ReportBugFeedbackToastVariant = 'success' | 'error';

export type ReportBugFeedbackToastProps = {
  toastId: string | number;
  titleKey: string;
  descriptionKey: string;
  variant: ReportBugFeedbackToastVariant;
};

export const ReportBugFeedbackToast: FC<ReportBugFeedbackToastProps> = ({
  toastId,
  titleKey,
  descriptionKey,
  variant
}) => {
  const {t} = useTranslation('common');

  return (
    <ToastCard
      iconName={variant === 'success' ? 'sollapay:check' : 'sollapay:close'}
      title={t(titleKey)}
      description={t(descriptionKey)}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('reportBug.toastClose')}
    />
  );
};

export function showReportBugFeedbackToast(
  titleKey: string,
  descriptionKey: string,
  variant: ReportBugFeedbackToastVariant
): void {
  toast.custom(
    id => (
      <ReportBugFeedbackToast
        toastId={id}
        titleKey={titleKey}
        descriptionKey={descriptionKey}
        variant={variant}
      />
    ),
    {duration: 5000}
  );
}
